module.exports = __webpack_public_path__ + "img/1.f517a84b.png";